document.addEventListener("DOMContentLoaded", function () {
  /* CHRISTMAS THEME */
  
  /* END CHRISTMAS THEME */

  // REPLACE UAE CURRENCY
  if (window.location.href.includes("en-ae")) {
    // Function to replace Dhs. with AED
    function replaceDhs(el) {
        if (el.textContent.includes("Dhs.")) {
            el.textContent = el.textContent.replace(/Dhs\./g, "AED");
        }
    }

    // Initial interval for dynamically loaded elements (first 5 seconds)
    const interval = setInterval(() => {
        document.querySelectorAll("#dynamic-pricing-bundle-product-page .ab-bundle-product-price").forEach(replaceDhs);
        document.querySelectorAll("#dynamic-pricing-bundle-product-page .ab-bundle-checkout-total-bundle-final-price").forEach(replaceDhs);
    }, 100);

    setTimeout(() => clearInterval(interval), 5000);

    // Observe checkout total prices for content changes
    const checkoutTotals = document.querySelectorAll("#dynamic-pricing-bundle-product-page .ab-bundle-checkout-total-bundle-final-price");
    checkoutTotals.forEach(el => {
        const observer = new MutationObserver(() => replaceDhs(el));
        observer.observe(el, { childList: true, characterData: true, subtree: true });
    });
}
  // END REPLACE UAE CURRENCY

  // NEW FLAVOUR COUNTDOWN
  function mysteryCountdown() {
    const targetHref_1 = "/collections/blocks/products/mystery-flavour-chocolate-block";
    const targetHref_2 = "/collections/shop/products/mystery-flavour-chocolate-block";

    function getNextTargetDate() { // 1st Wednesday of this or next month at 8AM
      const now = new Date();

      function firstWednesday(year, month) {
        const d = new Date(year, month, 1, 8, 0, 0); // 8:00 AM
        const day = d.getDay(); // 0=Sun, 3=Wed
        const daysToAdd = (day <= 3) ? (3 - day) : (10 - day);
        d.setDate(d.getDate() + daysToAdd);
        return d;
      }

      const thisMonthTarget = firstWednesday(now.getFullYear(), now.getMonth());

      // If today is before this month's target → use it
      if (now < thisMonthTarget) {
        return thisMonthTarget;
      }

      // Otherwise → first Wednesday of next month
      return firstWednesday(now.getFullYear(), now.getMonth() + 1);
    }

    let targetDate = getNextTargetDate();

    function addCountdown(thumbnail) {
      if (thumbnail.querySelector(".product-item__countdown-overlay")) return;

      thumbnail.style.position = "relative";

      const overlay = document.createElement("div");
      overlay.className = "product-item__countdown-overlay";

      thumbnail.appendChild(overlay);

      let resetTimeout = null;

      const timer = setInterval(() => {
        const now = new Date();
        const diff = targetDate - now;

        if (diff <= 0) {
          if (!resetTimeout) {
            overlay.textContent = "Launched!";
            resetTimeout = setTimeout(() => {
              targetDate = getNextTargetDate();
              resetTimeout = null;
            }, 60000);
          }
          return;
        }

        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((diff / (1000 * 60)) % 60);
        const seconds = Math.floor((diff / 1000) % 60);
        const daytext = days === 1 ? "day" : "days";
        const hourtext = hours === 1 ? "hour" : "hours";
        const minutetext = minutes === 1 ? "minute" : "minutes";
        const secondtext = seconds === 1 ? "second" : "seconds";

        if (diff > 86400000) {
          overlay.textContent = `Revealed in ${days} ${daytext}`;
        } else if (diff > 3600000) {
          overlay.textContent = `Revealed in ${hours} ${hourtext}`;
        } else if (diff > 60000) {
          overlay.textContent = `Revealed in ${minutes} ${minutetext} ${seconds} ${secondtext}`;
        } else {
          overlay.textContent = `Revealed in ${seconds} ${secondtext}`;
        }
      }, 1000);
    }

    const interval = setInterval(() => {
      const thumbnail_1 = document.querySelector(
        `.product-item__link[href="${targetHref_1}"] .product-item__thumbnail`
      );
      const thumbnail_2 = document.querySelector(
        `.product-item__link[href="${targetHref_2}"] .product-item__thumbnail`
      );
      if (thumbnail_1) {
        addCountdown(thumbnail_1);
        clearInterval(interval);
      } else if (thumbnail_2) {
        addCountdown(thumbnail_2);
        clearInterval(interval);
      }
    }, 500);
  }

  mysteryCountdown();
  // END NEW FLAVOUR COUNTDOWN

  // REFRESH WHEN SUBSCRIPTION ADDED TO CART
  const subscriptionItem = document.querySelector("#item-45049595920441");
  const isChocedInsider = window.location.href.includes("products/choced-insider");

  if (subscriptionItem && isChocedInsider) {
    const sidebarHandle = document.querySelector(".sidebar__cart-handle");
    if (sidebarHandle) {
      sidebarHandle.click();
    }
  }
  // END REFRESH WHEN SUBSCRIPTION ADDED TO CART

  // CUSTOM VIDEO IMAGE ANIMATION
  const videoAnimation = document.querySelector('.video-animation');
  const customBackgroundVideo = document.querySelector('.custom-video-background');

  let desktopObserver = null;
  let rafId = null;

  const isMobile = () => window.matchMedia('(max-width: 768px)').matches;

  function startDesktopObserver() {
    if (!customBackgroundVideo || !videoAnimation) return;
    if (desktopObserver) return;

    desktopObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const ratio = entry.intersectionRatio;
        if (ratio >= 0.9) videoAnimation.classList.add('animate');
        else if (ratio <= 0.1) videoAnimation.classList.remove('animate');
      });
    }, { threshold: [0.1, 0.9] });

    desktopObserver.observe(customBackgroundVideo);
  }

  function stopDesktopObserver() {
    if (desktopObserver) {
      desktopObserver.disconnect();
      desktopObserver = null;
    }
  }

  function mobileCheck() {
    if (!customBackgroundVideo || !videoAnimation) return;

    if (rafId) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(() => {
      const rect = customBackgroundVideo.getBoundingClientRect();
      const elementCenter = rect.top + rect.height / 2;
      const viewportCenter = window.innerHeight / 2;

      const visiblePx = Math.max(0, Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0));
      const ratio = rect.height > 0 ? visiblePx / rect.height : 0;

      const centerTolerance = window.innerHeight * 0.05; 

      if (Math.abs(elementCenter - viewportCenter) <= centerTolerance) {
        videoAnimation.classList.add('animate');
      } 
      else if (ratio <= 0.1) {
        videoAnimation.classList.remove('animate');
      }
    });
  }

  function startMobileHandlers() {
    mobileCheck();
    window.addEventListener('scroll', mobileCheck, { passive: true });
    window.addEventListener('resize', mobileCheck);
    window.addEventListener('orientationchange', mobileCheck);
  }

  function stopMobileHandlers() {
    if (rafId) { cancelAnimationFrame(rafId); rafId = null; }
    window.removeEventListener('scroll', mobileCheck);
    window.removeEventListener('resize', mobileCheck);
    window.removeEventListener('orientationchange', mobileCheck);
  }

  function setupBehavior() {
    stopDesktopObserver();
    stopMobileHandlers();

    if (isMobile()) {
      startMobileHandlers();
    } else {
      startDesktopObserver();
    }
  }

  setupBehavior();
  window.addEventListener('resize', setupBehavior);
  window.addEventListener('orientationchange', setupBehavior);
  // END CUSTOM VIDEO IMAGE ANIMATION

  // HOMEPAGE ALL REVIEW
  document.querySelectorAll('.scrolling-text-item').forEach(el => {
    el.innerHTML = el.innerHTML
      .replace(/\bgood\b/gi, '<span class="highlight-word-1">good</span>')
      .replace(/\bgreat\b/gi, '<span class="highlight-word-1">great</span>')
      .replace(/\bamazing\b/gi, '<span class="highlight-word-1">amazing</span>')
      .replace(/\bbest\b/gi, '<span class="highlight-word-1">best</span>')
      .replace(/\b10\/10\b/g, '<span class="highlight-word-1">10/10</span>')
      .replace(/\blove\b/gi, '<span class="highlight-word-2">love</span>')
      .replace(/\bloved\b/gi, '<span class="highlight-word-2">loved</span>')
      .replace(/\blovely\b/gi, '<span class="highlight-word-2">lovely</span>')
      .replace(/\bwow\b/gi,'<span class="highlight-word-2">wow</span>')
      .replace(/\bwoow\b/gi,'<span class="highlight-word-2">woow</span>')
      .replace(/\bwooooooow\b/gi, '<span class="highlight-word-2">wooooooow</span>')
      .replace(/\benjoyed\b/gi, '<span class="highlight-word-2">enjoyed</span>')
      .replace(/\bdelicious\b/gi, '<span class="highlight-word-3">delicous</span>')
      .replace(/\byummy\b/gi, '<span class="highlight-word-3">yummy</span>')
      .replace(/\byummm\b/gi, '<span class="highlight-word-3">yummm</span>')
      .replace(/\bfabulous\b/gi, '<span class="highlight-word-3">fabulous</span>')
      .replace(/\blush\b/gi, '<span class="highlight-word-3">lush</span>');
  });
  // END HOMEPAGE ALL REVIEW

  // PRODUCT LABEL IMAGE ANIMATION
  const labelImages = document.querySelectorAll('.product-item__badge .product-label-image');
  function labelHandleScroll() {
    labelImages.forEach(img => {
      const rect = img.getBoundingClientRect();
      const labelWindowMiddle = window.innerHeight / 2;
      if (rect.top <= labelWindowMiddle) {
        img.style.top = '94%';
        img.style.opacity = '1';
      } else {
        img.style.top = '0%';
        img.style.opacity = '0';
      }
    });
  }
  window.addEventListener('scroll', labelHandleScroll);
  // END PRODUCT LABEL IMAGE ANIMATION

  // PRODUCT BUTTON ANIMATION
  const buttonImages = document.querySelectorAll('.product_link .product-label-image');
  function buttonHandleScroll() {
    buttonImages.forEach(img => {
      const rect = img.getBoundingClientRect();
      const buttonWindowMiddle = window.innerHeight / 1.5;
      if (rect.top <= buttonWindowMiddle) {
        img.style.top = '99.5%';
        img.style.opacity = '1';
      } else {
        img.style.top = '95%';
        img.style.opacity = '0';
      }
    });
  }
  window.addEventListener('scroll', buttonHandleScroll);
  // END PRODUCT LABEL IMAGE ANIMATION

  // SOCIAL BUTTON ANIMATION
  const socialImages = document.querySelectorAll('.rich-text__button .button .product-label-image');
  function socialHandleScroll() {
    socialImages.forEach(img => {
      const rect = img.getBoundingClientRect();
      const socialWindowMiddle = window.innerHeight / 1.5;
      if (rect.top <= socialWindowMiddle) {
        img.style.marginTop = '53px';
        img.style.opacity = '1';
      } else {
        img.style.marginTop = '15px';
        img.style.opacity = '0';
      }
    });
  }
  window.addEventListener('scroll', socialHandleScroll);
  // END SOCIAL LABEL IMAGE ANIMATION

  const qtyInput = document.querySelector('.quantity__selector');
  const plusBtn = document.querySelector('.quantity__plus');
  const minusBtn = document.querySelector('.quantity__minus');
  const minQty = qtyInput ? parseInt(qtyInput.min) || 1:1;
  let quantity = minQty;

  const tableRows = Array.from(document.querySelectorAll('.bulk-discount-table tbody tr'));

  function updateTableHighlight() {
    // Remove all highlights
    tableRows.forEach(row => row.classList.remove('active'));

    // Only highlight the highest eligible tier
    let matchedRow = null;
    tableRows.forEach(row => {
      const min = parseInt(row.dataset.min);
      if (quantity >= min) {
        matchedRow = row;
      }
    });

    if (matchedRow) {
      matchedRow.classList.add('active');
    }
  }

  if (plusBtn) {
    plusBtn.addEventListener('click', function () {
      quantity++;
      qtyInput.value = quantity;
      updateTableHighlight();
    });
  };

  if (minusBtn) {
    minusBtn.addEventListener('click', function () {
      if (quantity > minQty) {
        quantity--;
        qtyInput.value = quantity;
        updateTableHighlight();
      }
    });
  };

  updateTableHighlight();
});

window.addEventListener('DOMContentLoaded', () => {
    initializeCardQuantity();
    const observer = new MutationObserver(() => {
        initializeCardQuantity();
    });
    observer.observe(document.querySelector("#AjaxCartForm"), { childList: true, subtree: true });
});

function initializeCardQuantity() {
    document.querySelectorAll('.cart-quantity__btn').forEach(button => {
        button.addEventListener('click', (e) => {
            e.preventDefault();
            const input = button.parentElement.querySelector('.qty');
            console.log(input);
            let currentValue = parseInt(input.value);

            if (button.classList.contains('cart-quantity__plus')) {
                input.value = currentValue + 1;
            } else if (button.classList.contains('cart-quantity__minus') && currentValue > 0) {
                input.value = currentValue - 1;
            }

            input.dispatchEvent(new Event('input', { bubbles: true }));
        });
    })
}

// FREE SHIPPING NOTIFICATION
const freeShippingEl = document.querySelector('.free-shipping-notification');
const freeShippingText = freeShippingEl?.querySelector('span');
const threshold = 75;       // free shipping threshold
const productPrice = 22;    // price per product
let lastTotal = null;

function updateFreeShipping() {
  if (!freeShippingEl || !freeShippingText) return;

  const cartTotalEl = document.getElementById('CartTotal');
  if (!cartTotalEl) {
    freeShippingEl.classList.remove('show');
    return;
  }

  const totalText = cartTotalEl.querySelector('strong')?.textContent
    .replace(/[^0-9.]/g, '')
    .trim();
  
  const totalAmount = parseFloat(totalText.replace(/,/g, '')) || 0;

  if (totalAmount === 0) {
    freeShippingEl.classList.remove('show');
  } else if (totalAmount >= threshold) {
    freeShippingText.textContent = `Congrats! You've unlocked free shipping.`;
  } else {
    const remainingAmount = threshold - totalAmount;
    const remainingQty = Math.ceil(remainingAmount / productPrice);

    freeShippingText.textContent = `Add ${remainingQty} more block${remainingQty > 1 ? 's' : ''} or spread${remainingQty > 1 ? 's' : ''} to unlock free shipping.`;

    freeShippingEl.classList.add('show');
  }

  lastTotal = totalAmount;
}

setInterval(updateFreeShipping, 1000);

updateFreeShipping();

const maxWait = 5000;
const pollInterval = 200;
let waited = 100;

const interval = setInterval(function () {
  const freeShippingNotification = document.querySelector('.free-shipping-notification');
  const productLabelImage = document.querySelector('.free-shipping-notification .product-label-image');


  if (freeShippingNotification) {
    clearInterval(interval);

    freeShippingNotification.style.transition = 'box-shadow 1s ease-in-out, transform 1s ease-in-out';
    
    let glow = true;
    const pulse = setInterval(() => {
      freeShippingNotification.style.boxShadow = glow
        ? '0 0 8px 2px rgb(143,103,73)'
        : '0 0 2px 1px rgba(255, 193, 7, 0.2)';
      freeShippingNotification.style.transform = glow
        ? 'scale(1.01)'
        : 'scale(1)';

      if (productLabelImage.style.display === 'none' || !productLabelImage.style.display) {
        productLabelImage.style.display = 'inline-block'; 
        productLabelImage.style.opacity = '0';
        productLabelImage.style.transform = 'translateY(-10px)';
        productLabelImage.style.transition = 'opacity 1s ease, transform 1s ease';

        setTimeout(() => {
          productLabelImage.style.opacity = '1';
          productLabelImage.style.transform = 'translateY(0)';
        }, 10);
      }

      glow = !glow;
    }, 1000);
  }

  waited += pollInterval;
  if (waited >= maxWait) clearInterval(interval);
}, pollInterval);




